import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/layouts/auth.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/app/layouts/blank.vue").then(m => m.default || m)),
  catalog: defineAsyncComponent(() => import("/app/layouts/catalog.vue").then(m => m.default || m)),
  chats: defineAsyncComponent(() => import("/app/layouts/chats.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  office: defineAsyncComponent(() => import("/app/layouts/office.vue").then(m => m.default || m)),
  ticket: defineAsyncComponent(() => import("/app/layouts/ticket.vue").then(m => m.default || m))
}